import { Container } from "@material-ui/core";
import useLanguageStore from "@stores/languageStore";
import { useTranslation } from "react-i18next";
import SEOHead from "../../components/SEOHead";
import SectionHeader from "../../components/SectionHeader";

const TermsPage = () => {
	const { t } = useTranslation();
	const { language } = useLanguageStore();
	const isRtl = language === "he";

	return (
		<div
			className={`min-h-[calc(100vh-64px)] py-20 sm:py-32 max-w-[100vw] overflow-x-hidden ${
				isRtl ? "rtl" : "ltr"
			}`}
		>
			<SEOHead
				title={t("terms.title")}
				description={t("terms.intro").substring(0, 160)}
			/>
			<Container maxWidth="lg" className="px-4 sm:px-8">
				<SectionHeader
					title={t("terms.title")}
					className="mb-8"
					titleWeight="800"
                    component="h1"
				/>

				<div
					className={`leading-relaxed text-base mb-8 max-w-4xl mx-auto ${isRtl ? "text-right" : "text-left"}`}
				>
					<p className="mb-8 text-lg font-semibold text-gray-600">
						{t("terms.lastUpdated")}
					</p>

					<p className="mb-8 text-lg">{t("terms.intro")}</p>

					{/* 1. General */}
					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("terms.general.title")}
						</h2>
						<p className="mb-4">{t("terms.general.text")}</p>
					</section>

					{/* 2. Custom Orders */}
					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("terms.customOrders.title")}
						</h2>
						<p className="mb-4">{t("terms.customOrders.text")}</p>
						<ul className="list-disc pr-6 mb-4 space-y-2">
							<li>{t("terms.customOrders.cancellations")}</li>
							<li>{t("terms.customOrders.approval")}</li>
						</ul>
					</section>

					{/* 3. Stone Nature */}
					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("terms.stoneNature.title")}
						</h2>
						<p className="mb-4">{t("terms.stoneNature.text")}</p>
						<ul className="list-disc pr-6 mb-4 space-y-2">
							<li>{t("terms.stoneNature.variations")}</li>
							<li>{t("terms.stoneNature.imperfections")}</li>
						</ul>
					</section>

					{/* 4. Simulator */}
					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("terms.simulator.title")}
						</h2>
						<p className="mb-4">{t("terms.simulator.text")}</p>
						<ul className="list-disc pr-6 mb-4 space-y-2">
							<li>{t("terms.simulator.general")}</li>
							<li>{t("terms.simulator.colors")}</li>
						</ul>
					</section>

                    {/* 5. Delivery */}
                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-4 text-[#063447]">
                            {t("terms.delivery.title")}
                        </h2>
                        <p className="mb-4">{t("terms.delivery.text")}</p>
                        <ul className="list-disc pr-6 mb-4 space-y-2">
                            <li>{t("terms.delivery.forceMajeure")}</li>
                            <li>{t("terms.delivery.bureaucracy")}</li>
                        </ul>
                    </section>

                    {/* 6. IP */}
                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-4 text-[#063447]">
                            {t("terms.ip.title")}
                        </h2>
                        <p className="mb-4">{t("terms.ip.text")}</p>
                    </section>

                    {/* 7. Warranty */}
                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-4 text-[#063447]">
                            {t("terms.warranty.title")}
                        </h2>
                        <p className="mb-4">{t("terms.warranty.text")}</p>
                    </section>

                    {/* 8. Jurisdiction */}
                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-4 text-[#063447]">
                            {t("terms.jurisdiction.title")}
                        </h2>
                        <p className="mb-4">{t("terms.jurisdiction.text")}</p>
                    </section>

				</div>
			</Container>
		</div>
	);
};

export default TermsPage;



